import { Link, useLocation } from "react-router-dom";
import { ArrowRight, Menu, X } from "lucide-react";
import { NAV_LINKS } from "../../data/landingPageContent";
import { ButtonLink, HashLink, LOGO_SRC, WRAP } from "./ui";

export default function Navbar({ scrolled, menuOpen, setMenuOpen }) {
  const closeMenu = () => setMenuOpen(false);
  const onPricing = useLocation().pathname === "/pricing";

  return (
    <header
      className={`sticky top-0 z-50 border-b transition-all duration-300 ${
        scrolled
          ? "bg-white shadow-[0_8px_30px_rgba(6,26,33,0.10)] border-slate-200"
          : "bg-white border-slate-200"
      }`}
    >
      <div className={`${WRAP} flex items-center justify-between h-[84px]`}>
        <HashLink href="#top" className="flex items-center gap-3.5" aria-label="IZSales home">
          <img src={LOGO_SRC} alt="IZSoftwares logo" className="w-auto h-12" />
          <span className="text-[26px] font-extrabold tracking-tight text-[#061A21]">IZSales</span>
        </HashLink>

        <div className="flex items-center gap-3 xl:gap-4">
          <nav className="items-center hidden gap-1 xl:flex" aria-label="Main">
            {NAV_LINKS.map((link) => (
              <HashLink
                key={link.href}
                href={link.href}
                className="px-4 py-2.5 text-[15px] font-medium transition-colors rounded-lg text-slate-600 hover:text-[#061A21] hover:bg-slate-100"
              >
                {link.label}
              </HashLink>
            ))}
            <Link
              to="/pricing"
              aria-current={onPricing ? "page" : undefined}
              className={`px-4 py-2.5 text-[15px] font-medium transition-colors rounded-lg ${
                onPricing
                  ? "text-[#007a90] bg-slate-100"
                  : "text-slate-600 hover:text-[#061A21] hover:bg-slate-100"
              }`}
            >
              Pricing
            </Link>
          </nav>
          <ButtonLink href="#how-it-works" variant="outline" className="hidden lg:inline-flex !h-11 !px-5">
            See how it works
          </ButtonLink>
          <button
            type="button"
            onClick={() => setMenuOpen((o) => !o)}
            className="flex items-center justify-center border rounded-lg w-11 h-11 xl:hidden border-slate-200 text-slate-700 hover:bg-slate-100"
            aria-label={menuOpen ? "Close menu" : "Open menu"}
            aria-expanded={menuOpen}
          >
            {menuOpen ? <X size={20} /> : <Menu size={20} />}
          </button>
        </div>
      </div>

      {menuOpen && (
        <div className="bg-white border-t xl:hidden border-slate-100">
          <div className={`${WRAP} flex flex-col gap-1 py-4`}>
            {NAV_LINKS.map((link) => (
              <HashLink
                key={link.href}
                href={link.href}
                onClick={closeMenu}
                className="px-3 py-3 text-[15px] font-medium rounded-lg text-slate-700 hover:bg-slate-50"
              >
                {link.label}
              </HashLink>
            ))}
            <Link
              to="/pricing"
              onClick={closeMenu}
              aria-current={onPricing ? "page" : undefined}
              className={`px-3 py-3 text-[15px] font-medium rounded-lg hover:bg-slate-50 ${
                onPricing ? "text-[#007a90]" : "text-slate-700"
              }`}
            >
              Pricing
            </Link>
            <ButtonLink to="/pricing" className="w-full mt-3">
              View Pricing <ArrowRight size={16} />
            </ButtonLink>
          </div>
        </div>
      )}
    </header>
  );
}